module.exports = __webpack_public_path__ + "static/img/DabHands.1ca3d441.png";